import Header from './Header';
import Video from './Video';
import TOC from './TOC';
import Tracker from './Tracker';
import CrtText from './CrtText';



const components = {
  Header,
  Video,
  TOC,
  Tracker,
  CrtText
}


export default components;
